import { render, staticRenderFns } from "./biantenggongzi.vue?vue&type=template&id=3318c6e6&scoped=true&"
import script from "./biantenggongzi.vue?vue&type=script&lang=js&"
export * from "./biantenggongzi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3318c6e6",
  null
  
)

export default component.exports